import React, {Component} from 'react';
import {connect} from 'react-redux';

import {SituacaoKeys, RouteKeys} from '../../constants';
import {
  ValidationService,
  StringService,
  CacheService,
  NotificationService,
} from '../../services';
import validation from './validation';

import {
  ScreenNotificationDefault,
  HeaderPhoto,
  Footer,
  InputText,
} from '../../components';
import {redirectToDataContact} from '../../ducks/Navigate';
import {
  dadosPessoaisAdicionar,
  updateDadosPessoais,
  updateProps,
} from '../../ducks/Customer';
import {parametroSistemaBuscar} from '../../ducks/SystemParameter';
import {ParamKeys} from '../../constants';

import './styles.scss';

class DataRegistration extends Component {
  formIsValid = () =>
    ValidationService.validate(
      {
        ...this.props.dadosPessoais,
        autorizacoes: this.props.autorizacoes,
        autorizacoesCompare: true,
      },
      validation,
    );

  async componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.DataRegistration.title,
    );
    await this.props.parametroSistemaBuscar(
      ParamKeys.PARAMETRO_SISTEMA_IDADE_MAXIMA,
    );

    CacheService.save('PARAMETRO_SISTEMA_IDADE_MAXIMA', this.props.valor);
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    console.log(
      'Dados preenchidos no formulário do data-registration: ',
      this.props.dadosPessoais,
    );
    if (!this.formIsValid()) return;

    this.props.redirectToDataContact();
  };

  handleChange = (prop, value) => {
    this.props.updateDadosPessoais({prop, value});
  };

  handleAutorizacoesChange = (prop, value) => {
    this.props.updateProps({prop, value});
  };

  filterName = (value) => {
    var valueTemp = StringService.clearString(value);
    return valueTemp.toUpperCase();
  };

  isDisabled = () => {
    return this.props.situacao !== SituacaoKeys.Convidado;
  };

  handleTerms = () => {
    NotificationService.showTerms(`
    <div style="width: 100%; height: 400px; -webkit-overflow-scrolling: touch; overflow-y: auto;">
      <iframe src="https://portal.credz.com.br/politica-de-privacidade" style="height: 100%; width: 100%; border: none; display: block;"></iframe>
    </div>`);
  };

  render() {
    return (
      <ScreenNotificationDefault
        title={<HeaderPhoto title="Preencha as informações abaixo" />}
        contentCustom={
          <div className="div-data-registration">
            <form className="form" id="frm" onSubmit={this.handleSubmit}>
              <InputText
                type="text"
                value={this.props.dadosPessoais.cpf}
                disabled
                id="cpf"
                name="cpf"
                placeholder="CPF"
                mask="999.999.999-99"
              />

              <InputText
                type="text"
                value={this.props.dadosPessoais.nome.toUpperCase()}
                id="nome"
                maxLength="100"
                onChange={(ev) =>
                  this.handleChange('nome', this.filterName(ev.target.value))
                }
                placeholder="Nome Completo"
              />

              <div className="form-group">
                <label className="form-label">Sexo</label>
                <div className="checkbox">
                  <input
                    className="form-field"
                    type="radio"
                    id="masculino"
                    name="sexo"
                    value="masculino"
                    checked={
                      this.props.dadosPessoais.sexo.toLowerCase() ===
                      'masculino'
                    }
                    onChange={(ev) =>
                      this.handleChange('sexo', ev.target.value)
                    }
                  />
                  <label htmlFor="masculino">Masculino</label>
                </div>

                <div className="checkbox">
                  <input
                    className="form-field"
                    type="radio"
                    id="feminino"
                    name="sexo"
                    value="feminino"
                    checked={
                      this.props.dadosPessoais.sexo.toLowerCase() === 'feminino'
                    }
                    onChange={(ev) =>
                      this.handleChange('sexo', ev.target.value)
                    }
                  />
                  <label htmlFor="feminino">Feminino</label>
                </div>
              </div>

              <InputText
                type="tel"
                value={this.props.dadosPessoais.nascimento}
                onChange={(ev) =>
                  this.handleChange('nascimento', ev.target.value)
                }
                mask="99/99/9999"
                id="nascimento"
                name="nascimento"
                placeholder="Data de Nascimento"
                disabled={this.isDisabled(this.props.situacao)}
              />

              <div className="form-group-checkbox">
                <input
                  className="styled-checkbox"
                  type="checkbox"
                  id="autorizacao"
                  name="autorizacao"
                  checked={this.props.autorizacoes ? true : false}
                  onChange={(ev) =>
                    this.handleAutorizacoesChange(
                      'autorizacoes',
                      ev.target.checked,
                    )
                  }
                />
                <label htmlFor="autorizacao"></label>
                <label htmlFor="autorizacao">
                  Aceito a política de privacidade,{' '}
                  <u onClick={this.handleTerms}>saiba mais</u>.
                </label>
              </div>
            </form>
          </div>
        }
        contentButtons={
          <div className="footer-data-registration">
            <Footer textNext="Próximo" nextForm="frm" hideBtnBack={true} />
          </div>
        }
      />
    );
  }
}

const mapStateToProps = ({customer, systemParameter}) => {
  const {dadosPessoais, situacao, autorizacoes} = customer;
  const {valor} = systemParameter;
  return {dadosPessoais, situacao, valor, autorizacoes};
};

export default connect(mapStateToProps, {
  redirectToDataContact,
  dadosPessoaisAdicionar,
  updateDadosPessoais,
  updateProps,
  parametroSistemaBuscar,
})(DataRegistration);
